import { useContext } from 'react';

import { Notes } from 'pages';

import { RouteProps } from 'routes/types';
import { Permissions } from './types';

import { PermissionConfigContext, PermissionConfig } from '.';

export const usePermissionConfig = () => {
  const { permissionsConfig, setPermissionsConfig } = useContext(
    PermissionConfigContext,
  );

  const addPermissionConfig = (rc: PermissionConfig) => {
    if (setPermissionsConfig) setPermissionsConfig(rc);
  };

  const getPermissionConfig = () => permissionsConfig;

  const hasAccess = (key: string) => {
    if (!permissionsConfig[key] && !key.includes('.')) return false;
    if (typeof permissionsConfig[key] === 'boolean')
      return permissionsConfig[key];

    const newKey = key.slice(0, key.indexOf('.'));

    const subKey = key.slice(key.indexOf('.') + 1);
    return (permissionsConfig[newKey] as Permissions)[subKey];
  };

  const getPermissionRoutes = () => {
    const conditionalPaths: RouteProps[] = [];
    const notesRoute: RouteProps = {
      path: '/enduser/:id/notes',
      name: 'PAGE.NAME.NOTES',
      Element: Notes,
      hideMenu: false,
    };

    if (hasAccess('note')) conditionalPaths.push(notesRoute);

    return conditionalPaths;
  };

  return {
    addPermissionConfig,
    getPermissionConfig,
    getPermissionRoutes,
    hasAccess,
  };
};

export default usePermissionConfig;
